import React from "react";
import ReactDOM from "react-dom";
import Dashboard from "./components/Dashboard";
import "./styles.css";

ReactDOM.render(
  <React.StrictMode>
    <Dashboard />
  </React.StrictMode>,
  document.getElementById("root")
);
